import * as moment from 'moment';

export enum PlanType {
  OneTime = 'ONE_TIME',
  Installmaent = 'INSTALLMENT',
  Recurring = 'RECURRING',
  Credit = 'CREDIT',
}

// Api Models

export interface ApiPatientBalanceResponse {
  balance: number;
}

export interface ApiPaymentRequest {
  planType: PlanType.OneTime;
  total: number; // double
  currency: 'USD';
  startedOn: string; // date-time string
  paymentMethodId: string;
}

export interface ApiReleaseShipmentRequest {
  patientId: number;
  referenceNumber: number;
  targetedShipDate: string;
  paymentProcessed: string;
  paymentType?: string;
  patientEstimatedCopay?: number;
  patientBalance?: number;
  patientResponsibility?: number;
}

// Frontend Models

export interface PatientBalance extends ApiPatientBalanceResponse {}

// Form Models

export interface MakePaymentFormValues {
  paymentMethodId: string;
  paymentAmount: number;
}

// Mappers

export const buildPaymentRequest = (formValues: MakePaymentFormValues): ApiPaymentRequest => ({
  planType: PlanType.OneTime,
  total: formValues.paymentAmount,
  currency: 'USD',
  startedOn: moment.utc().format(),
  paymentMethodId: formValues.paymentMethodId,
});

export const mapPatientBalance = (apiPatientBalance: ApiPatientBalanceResponse): PatientBalance => apiPatientBalance;
